import { parseDomain } from 'helpers/parseDomain';

import {
  Input,
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { CheckoutService } from '../checkout.service';

import { AuthService } from 'services/auth.service';
import { CartService } from 'services/cart.service';
import { OrderService } from 'services/order.service';
import { DialogService } from 'services/dialog.service';
import { BugsnagService } from 'services/bugsnag.service';
import { ProductService } from 'services/product.service';
import { EcommerceService } from 'services/ecommerce.service';

import shippingHtml from './shipping.html';
import './shipping.scss';

@Component({
  selector: 'gw-portal-checkout-shipping',
  template: shippingHtml,
})
export class CheckoutShippingComponent implements OnInit {
  public GW = (<any>window).GW;
  public fbq = (<any>window).fbq;
  public laroute = (<any>window).laroute;

  public shippingForm;
  public user = this.GW.user;
  public order = this.orderService.order;
  public cart = this.cartService.getCart();
  public cheapestOutbound;
  public model = {
    outbound: null,
  };

  public state = {
    mailaway: false,
    submitting: false,
    outboundOptions: null,
  };

  public lang = {
    standard_overnight: {
      title: '<strong>FedEx Standard Overnight</strong>',
      desc: 'Get it Next Day by 3 PM',
    },
    priority_overnight: {
      title: '<strong>FedEx Priority Overnight</strong>',
      desc: 'Get it Next Day by 10:30 AM',
    },
    first_overnight: {
      title: '<strong>FedEx First Overnight</strong>',
      desc: 'Get it Next Day by 8 AM',
    },
    priority_saturday_overnight: {
      title: '<strong>FedEx Priority Saturday Overnight</strong> (Mid Day)',
      desc: 'Get it on Saturday by 3 PM',
    },
    priority_saturday_overnight_early: {
      title: '<strong>FedEx Priority Saturday Overnight</strong> (Early Day)',
      desc: 'Get it on Saturday by 8 AM',
    },
  };

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CartService) private cartService: CartService,
    @Inject(OrderService) private orderService: OrderService,
    @Inject(DialogService) private dialogService: DialogService,
    @Inject(ProductService) private productService: ProductService,
    @Inject(BugsnagService) private bugsnagService: BugsnagService,
    @Inject(EcommerceService) private ecommerceService: EcommerceService,
  ) {}

  /**
   * Component init hook
   */
  ngOnInit() {
    // Make sure they complete account step first
    if (!this.user && this.order.account.email === '') {
      return window.location.assign(this.laroute.route('checkout.account'));
    }

    this.ecommerceService.checkout(3, this.cart);

    if (this.displayOutboundOptions()) {
      // Map outbound options from window data
      this.state.outboundOptions = this.productService
        .mapOutboundOptions(this.GW.outboundOptions);

      // Fetch cheapest option
      this.cheapestOutbound = this.state.outboundOptions[0];

      // If already in order, selected it
      const order = this.cartService.getFirstOrderWithShipping();
      if (order.outbound && order.outbound.value) {
        this.model.outbound = this.state.outboundOptions
          .find(opt => opt.value === order.outbound.value);
      } else {
        // Pre-select cheapest option
        this.model.outbound = this.cheapestOutbound;
      }

      this.updateOutboundShipping();
    }

    if (this.user) {
      this.prefillAddress();
    }
  }

  displayOutboundOptions() {
    const orderItem = this.cartService.getFirstOrderWithShipping();
    const product = this.cart.products[orderItem.productId];
    const option = this.cart.options[orderItem.optionsId];

    if (this.cartService.determineMailaway(product, option)) {
      this.state.mailaway = true;
      return false;
    }

    if (orderItem.requireShipping === false) {
      return false;
    }

    return true;
  }

  prefillAddress() {
    const shippingAddress = this.user.addresses
      .find(addr => addr.type === 'shipping');

    if (!shippingAddress) {
      return;
    }

    this.order.shippingAddress.address = shippingAddress.address_1;
    this.order.shippingAddress.address2 = shippingAddress.address_2;
    this.order.shippingAddress.locality = shippingAddress.city;
    this.order.shippingAddress.region = shippingAddress.state;
    this.order.shippingAddress.country = shippingAddress.country;
    this.order.shippingAddress.postalCode = shippingAddress.postal_code;
  }

  updateOutboundShipping() {
    const item = this.cartService.getFirstOrderWithShipping();
    item.outbound = this.model.outbound;
  }

  async submit() {
    // Is form valid?
    if (this.shippingForm.$invalid) {
      return;
    }

    this.state.submitting = true;

    try {
      await this.cartService.saveCart();
      return window.location.assign(this.laroute.route('checkout.submit'));
    } catch (e) {
      this.state.submitting = false;
      return this.dialogService.openAlert({});
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/shipping/shipping.component.ts